/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import PageTitle from '../components/PageTitle'
import NewsRecentArticles from '../components/NewsRecentArticles'
import NewsContact from '../components/NewsContact'
import NewsMediaGallery from '../components/NewsMediaGallery'
import getConfig from 'next/config'
import { InferGetServerSidePropsType } from 'next'
import Head from 'next/head'
const { publicRuntimeConfig } = getConfig()

const News = ({ newsItem, tabStateOption }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  enum tabStateOptions {
    recent = 'recent',
    prContacts = 'pr-contacts',
    mediaGallery = 'media-gallery',
    facts = 'facts'
  }

  const defaultTabStateOption: tabStateOptions = (Object.values(tabStateOptions).some((option: string) => option === tabStateOption)) ? tabStateOptions[Object.keys(tabStateOptions)[Object.values(tabStateOptions).indexOf(tabStateOption)]] : tabStateOptions.recent
  const [tabState, setTabState] = useState(defaultTabStateOption)

  const renderContent = () => {
    if (tabState === tabStateOptions.recent) {
      return (
        <div>
          <NewsRecentArticles recents={newsItem[0].template.recents} />
        </div>
      )
    } else if (tabState === tabStateOptions.prContacts) {
      return (
        <div>
          <NewsContact />
        </div>
      )
    } else if (tabState === tabStateOptions.mediaGallery) {
      return (
        <div>
          <NewsMediaGallery gallery={newsItem[0].template.gallery} />
        </div>
      )
    } else {
      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: newsItem[0].template.facts }} className='rte' />
        </div>
      )
    }
  }

  return (
    <div className="news">
      <Head>
        <title>News</title>
        <meta name="description" content="Get the latest pOpshelf news!" />
      </Head>
      <PageTitle title="in the news" />
      <div className="news__body">
        <div className="news__tabs">
          <button className={tabState === tabStateOptions.recent ? 'selected' : ''} id='recent' onClick={() => setTabState(tabStateOptions.recent)}>recent</button>
          <button className={tabState === tabStateOptions.prContacts ? 'selected' : ''} id='pr-contacts' onClick={() => setTabState(tabStateOptions.prContacts)}>pr contacts</button>
          <button className={tabState === tabStateOptions.mediaGallery ? 'selected' : ''} id='media-gallery' onClick={() => setTabState(tabStateOptions.mediaGallery)}>media gallery</button>
          <button className={tabState === tabStateOptions.facts ? 'selected' : ''} id='facts' onClick={() => setTabState(tabStateOptions.facts)}>facts</button>
        </div>
        {renderContent()}
      </div>
    </div >
  )
}

export default News

export const getServerSideProps = async ({ req, query }) => {
  const { publicRuntimeConfig } = getConfig()
  const res = await fetch(
    `${publicRuntimeConfig.APP_ENDPOINT}/api/productinfo/${publicRuntimeConfig.ENV}/news?popkey=${publicRuntimeConfig.POP_KEY}`,
    {
      headers: {
        deviceid: ''
      }
    }
  )
  const newsItem = await res.json()

  return {
    props: {
      newsItem: newsItem,
      tabStateOption: query.tabStateOption ? query.tabStateOption : 'recent'
    }
  }
}
